export const GET_SINGLE_COMPANY_REQUEST = 'GET_SINGLE_COMPANY_REQUEST';
export const GET_SINGLE_COMPANY_SUCCESS= 'GET_SINGLE_COMPANY_SUCCESS';
export const GET_SINGLE_COMPANY_FAILURE = 'GET_SINGLE_COMPANY_FAILURE';